import {useEffect, useMemo, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

import {mr} from "@pg-design/helpers-css";
import {CarOutlineIcon, HomeIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {rpFeatureFlagNewUserFlow} from "../../app/read_rp_environment_variables";
import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {useMapRegionDistrictsAndSurroundings} from "../../offer/map/hooks/use_map_region_districts_and_surroundings";
import {getMainCityBySelectedRegions} from "../../offer/map/utils/districts_and_surroundings/get_main_city_by_selected_regions";
import {validateSelectedRegionsWithAvailableDistrictsAndSurroundings} from "../../offer/map/utils/districts_and_surroundings/validate_selected_regions_with_available_districts_and_surroundings";
import {RegionType} from "../../region/types/RegionType";
import {searchFormActions} from "../slices/search_form_slice";
import {RegionSearchTabsType} from "../types/RegionSearchTabsType";

interface IProps {
    regionQuery?: string;
    onSearchTabChange?: (tab: RegionSearchTabsType) => void;
}

export const useRegionSearchTabs = (props: IProps = {}) => {
    const dispatch = useDispatch();

    const formValues = useSelector((state: IRPStore) => state.search.formValues);

    const currentTab = useSelector((state: IRPStore) => state.search.searchForm.locationSearchTab);
    const prevTabRef = useRef<null | RegionSearchTabsType>(null);

    const selectedRegions = formValues.search.regions as ISelectedRegion[];
    const {data: availableRegions} = useMapRegionDistrictsAndSurroundings({selectedRegions});

    const isDistrictTabAvailable = useMemo(() => {
        if (!rpFeatureFlagNewUserFlow) {
            return false;
        }

        const regionIsValidated =
            availableRegions && validateSelectedRegionsWithAvailableDistrictsAndSurroundings(formValues.search.regions, availableRegions.results);
        const mainCityIsExplicitlyIndicated = formValues.search.regions && getMainCityBySelectedRegions(formValues.search.regions);
        const atLeastOneDistrict = availableRegions && availableRegions.results.some((region) => region.type === RegionType.DISTRICT);

        return regionIsValidated && mainCityIsExplicitlyIndicated && atLeastOneDistrict;
    }, [formValues.search.regions, availableRegions]);

    useEffect(() => {
        if (prevTabRef.current !== null && typeof isDistrictTabAvailable === "undefined") {
            return;
        }

        if (isDistrictTabAvailable) {
            prevTabRef.current = RegionSearchTabsType.DISTRICTS;
            dispatch(searchFormActions.setLocationSearchTab(RegionSearchTabsType.DISTRICTS));
        } else {
            prevTabRef.current = RegionSearchTabsType.LOCATION;
            dispatch(searchFormActions.setLocationSearchTab(RegionSearchTabsType.LOCATION));
        }
    }, [isDistrictTabAvailable]);

    // auto change active tab to location if user typed any region query (only for district tab)
    // it is necessary to show available region hints
    useEffect(() => {
        if (typeof props.regionQuery !== "undefined" && props.regionQuery.length > 0 && currentTab === RegionSearchTabsType.DISTRICTS) {
            regionSearchTabChangeHandler(RegionSearchTabsType.LOCATION);
        }
    }, [props.regionQuery]);

    const regionSearchTabs = useMemo(() => {
        return isDistrictTabAvailable ? baseRegionSearchTabs : baseRegionSearchTabs.filter((record) => record.value !== RegionSearchTabsType.DISTRICTS);
    }, [isDistrictTabAvailable]);

    const regionSearchTabChangeHandler = (tab: RegionSearchTabsType) => {
        if (tab === RegionSearchTabsType.DISTRICTS && !isDistrictTabAvailable) {
            return;
        }

        dispatch(searchFormActions.setLocationSearchTab(tab));
        props.onSearchTabChange?.(tab);
    };

    return {
        activeRegionSearchTab: currentTab,
        regionSearchTabs,
        regionSearchTabChangeHandler
    };
};

const baseRegionSearchTabs = [
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <MapMarkerOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Lokalizacja
                </Text>
            </>
        ),
        value: RegionSearchTabsType.LOCATION
    },
    ...(rpFeatureFlagNewUserFlow
        ? [
              {
                  title: (
                      <>
                          <Text variant="body_copy_2" align="center">
                              <HomeIcon size="2" wrapperSize="2" css={mr(1)} />
                              Dzielnice
                          </Text>
                      </>
                  ),
                  value: RegionSearchTabsType.DISTRICTS
              }
          ]
        : []),
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <CarOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Czas dojazdu
                </Text>
            </>
        ),
        value: RegionSearchTabsType.TRAVEL_TIME
    }
];
import {useEffect, useMemo, useRef} from "react";
import {useDispatch, useSelector} from "react-redux";

import {mr} from "@pg-design/helpers-css";
import {CarOutlineIcon, HomeIcon, MapMarkerOutlineIcon} from "@pg-design/icons-module";
import {Text} from "@pg-design/text-module";

import {rpFeatureFlagNewUserFlow} from "../../app/read_rp_environment_variables";
import {IRPStore} from "../../app/rp_reducer";
import {ISelectedRegion} from "../../offer/list/actions/offer_list_selected_data_actions";
import {useMapRegionDistrictsAndSurroundings} from "../../offer/map/hooks/use_map_region_districts_and_surroundings";
import {getMainCityBySelectedRegions} from "../../offer/map/utils/districts_and_surroundings/get_main_city_by_selected_regions";
import {validateSelectedRegionsWithAvailableDistrictsAndSurroundings} from "../../offer/map/utils/districts_and_surroundings/validate_selected_regions_with_available_districts_and_surroundings";
import {RegionType} from "../../region/types/RegionType";
import {searchFormActions} from "../slices/search_form_slice";
import {RegionSearchTabsType} from "../types/RegionSearchTabsType";

interface IProps {
    regionQuery?: string;
    onSearchTabChange?: (tab: RegionSearchTabsType) => void;
}

export const useRegionSearchTabs = (props: IProps = {}) => {
    const dispatch = useDispatch();

    const formValues = useSelector((state: IRPStore) => state.search.formValues);

    const currentTab = useSelector((state: IRPStore) => state.search.searchForm.locationSearchTab);
    const prevTabRef = useRef<null | RegionSearchTabsType>(null);

    const selectedRegions = formValues.search.regions as ISelectedRegion[];
    const {data: availableRegions} = useMapRegionDistrictsAndSurroundings({selectedRegions});

    const isDistrictTabAvailable = useMemo(() => {
        if (!rpFeatureFlagNewUserFlow) {
            return false;
        }

        const regionIsValidated =
            availableRegions && validateSelectedRegionsWithAvailableDistrictsAndSurroundings(formValues.search.regions, availableRegions.results);
        const mainCityIsExplicitlyIndicated = formValues.search.regions && getMainCityBySelectedRegions(formValues.search.regions);
        const atLeastOneDistrict = availableRegions && availableRegions.results.some((region) => region.type === RegionType.DISTRICT);

        return regionIsValidated && mainCityIsExplicitlyIndicated && atLeastOneDistrict;
    }, [formValues.search.regions, availableRegions]);

    useEffect(() => {
        if (prevTabRef.current !== null && typeof isDistrictTabAvailable === "undefined") {
            return;
        }

        if (isDistrictTabAvailable) {
            prevTabRef.current = RegionSearchTabsType.DISTRICTS;
            dispatch(searchFormActions.setLocationSearchTab(RegionSearchTabsType.DISTRICTS));
        } else {
            prevTabRef.current = RegionSearchTabsType.LOCATION;
            dispatch(searchFormActions.setLocationSearchTab(RegionSearchTabsType.LOCATION));
        }
    }, [isDistrictTabAvailable]);

    // auto change active tab to location if user typed any region query (only for district tab)
    // it is necessary to show available region hints
    useEffect(() => {
        if (typeof props.regionQuery !== "undefined" && props.regionQuery.length > 0 && currentTab === RegionSearchTabsType.DISTRICTS) {
            regionSearchTabChangeHandler(RegionSearchTabsType.LOCATION);
        }
    }, [props.regionQuery]);

    const regionSearchTabs = useMemo(() => {
        return isDistrictTabAvailable ? baseRegionSearchTabs : baseRegionSearchTabs.filter((record) => record.value !== RegionSearchTabsType.DISTRICTS);
    }, [isDistrictTabAvailable]);

    const regionSearchTabChangeHandler = (tab: RegionSearchTabsType) => {
        if (tab === RegionSearchTabsType.DISTRICTS && !isDistrictTabAvailable) {
            return;
        }

        dispatch(searchFormActions.setLocationSearchTab(tab));
        props.onSearchTabChange?.(tab);
    };

    return {
        activeRegionSearchTab: currentTab,
        regionSearchTabs,
        regionSearchTabChangeHandler
    };
};

const baseRegionSearchTabs = [
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <MapMarkerOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Lokalizacja
                </Text>
            </>
        ),
        value: RegionSearchTabsType.LOCATION
    },
    ...(rpFeatureFlagNewUserFlow
        ? [
              {
                  title: (
                      <>
                          <Text variant="body_copy_2" align="center">
                              <HomeIcon size="2" wrapperSize="2" css={mr(1)} />
                              Dzielnice
                          </Text>
                      </>
                  ),
                  value: RegionSearchTabsType.DISTRICTS
              }
          ]
        : []),
    {
        title: (
            <>
                <Text variant="body_copy_2" align="center">
                    <CarOutlineIcon size="2" wrapperSize="2" css={mr(1)} />
                    Czas dojazdu
                </Text>
            </>
        ),
        value: RegionSearchTabsType.TRAVEL_TIME
    }
];
